module.exports = __webpack_public_path__ + "static/media/sellerpanel.8a264ce5.svg";